import { memo } from "react";

export const TypingIndicator = memo(() => {
  return (
    <div className="flex items-left gap-2 py-2" data-testid="typing-indicator">
      <div className="flex gap-1">
        <div className="w-2 h-2 rounded-full bg-gray-400 animate-bounce [animation-delay:-0.3s]" />
        <div className="w-2 h-2 rounded-full bg-gray-400 animate-bounce [animation-delay:-0.15s]" />
        <div className="w-2 h-2 rounded-full bg-gray-400 animate-bounce" />
      </div>
    </div>
  );
});
